// extracted by mini-css-extract-plugin
export var activityContainer = "_jv-0";
export var typingIndicatorContainer = "_jv-1";
export var typingIndicatorDot = "_jv-2";
export var wave = "_jv-3";